<template>
  <div
    class="podcast-episodes"
    data-test="podcast-episodes">
    <div
      v-if="isLoggedIn">
      <loader
        v-show="!episodes_loaded"
        center
        label="Fetching Podcasts Episodes ..."/>
      <div class="container">
        <library-menu
          :display-list="true"
          text="Latest Episodes"/>
      </div>
      <!-- Empty Shows Box -->
      <empty-shows
        v-show="!podcasts_episodes.length && episodes_loaded"
        option="podcast-episodes"/>

      <!-- Display Podcasts Episodes-->
      <div
        v-if="podcasts_episodes.length">
        <card-list-wrapper
          :episodes="podcasts_episodes"
          :bucket="{
            bucket_uuid: null,
            name: 'Latest Episodes',
            bucket_type:'episodes',
            position: 0,
            items_count: podcasts_episodes.length,
            media_size: 'episode_details'
          }"
          playlist-type="my-shows"
          data-test="latest-episodes"
        />
      </div>
      <loader
        v-show="podcasts_episodes.length && loading_more_episodes && !no_more_episodes"
        :with-margin="true"
        label="Fetching Podcasts Episodes ..."
      />
    </div>
  </div>
</template>
<script>
import Episode from '../../services/Episode';
import User from '../../services/User';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'Shows',
  components: {
    loader: () => import('../../components/Loader'),
    'card-list-wrapper': () => import('../../components/CardListWrapper'),
    'empty-shows': () => import('../../components/EmptyShows'),
    'library-menu': () => import('../../components/LibraryMenu'),
  },
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'My Shows',
      episode_service: new Episode(),
      user_service: new User(),
      podcasts_episodes: [],
      podcasts_episodes_response: [],
      episode_key_map: {},
      episodes_loaded: false,
      no_more_episodes: false,
      loading_more_episodes: false,
      page: 0,
      limit: 25,
      scroll_threshold: 200,
      isLoggedIn: this.$store.getters.loggedIn,
    };
  },
  beforeMount() {
    if (this.isLoggedIn) {
      this.loadPodcastEpisodeData();
    }
  },
  methods: {
    isExclusive(item) {
      return (item.season && item.season.podcast && item.season.podcast.is_exclusive) || false;
    },
    isFreeEpisode(item) {
      return (item.season && item.season.podcast && item.season.podcast.is_exclusive) && !item.is_exclusive;
    },
    loadPodcastEpisodeData() {
      this.episodes_loaded = false;
      this.loading_more_episodes = true;
      if (this.no_more_episodes) {
        this.episodes_loaded = true;
        return;
      }
      const prevLen = this.podcasts_episodes.length;
      this.episode_service.getAllPodcastEpisodes(this.limit, ++this.page)
        .then((tempArr) => {
          if (tempArr && tempArr.episodes.length < 25) {
            this.no_more_episodes = true;
            this.episodes_loaded = true;
          }
          this.podcasts_episodes = this.podcasts_episodes.concat(this.mapPodcastEpisodeData(tempArr.episodes));
          this.no_more_episodes = this.podcasts_episodes.length === prevLen;
          this.loading_more_episodes = false;
          this.episodes_loaded = true;
          this.registerInfiniteScrolling();
        })
        .catch(() => {
          this.no_more_episodes = true;
          this.loading_more_episodes = false;
          this.episodes_loaded = true;
        });
    },
    mapPodcastEpisodeData(temp) {
      temp = temp.map(item => ({
        ...item,
        progress: item.episode_listen ? item.episode_listen.elapsed : 0,
        display_image_url: item.display_image_url,
      }));
      return temp;
    },
    registerInfiniteScrolling() {
      document.addEventListener('scroll', this.infiniteScrollCallback);
    },
    infiniteScrollCallback() {
      const { clientHeight, scrollTop, scrollHeight } = document.documentElement;
      if (scrollTop + clientHeight + this.scroll_threshold >= scrollHeight) {
        if (this.episodes_loaded) {
          this.loadPodcastEpisodeData();
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

@media(max-width: 1024px) {
  .podcast-episodes {
    min-height: calc(100vh - 347px);
    .container {
      width: 100%;
      .top-bar {
        margin: 0 32px;
        padding-bottom: 13px;
      }
    }
  }
}
</style>
